import { useEffect } from "react";
import { GlobalStore } from "../store/global/GlobalStore";
import { Address } from "viem";
import * as echarts from "echarts/core";
import { CandlestickChart } from "echarts/charts";
import { CanvasRenderer } from "echarts/renderers";
import { DataZoomComponent, GridComponent, TooltipComponent } from "echarts/components";
import { getChartOptions } from "../utils/chartDataUtils";

export const useCandleStickChart = (chartData: Array<Array<number>>, elementId: Address) => {
  const theme = GlobalStore.useState(s => s.theme);
  useEffect(() => {
    const chartContainer = document.getElementById(elementId);
    if (!chartContainer) {
      console.log(`Element with ID '${elementId}' not found.`);
      return;
    }
    echarts.use([
      CandlestickChart,
      GridComponent,
      TooltipComponent,
      DataZoomComponent,
      CanvasRenderer,
    ]);
    const chart = echarts.init(chartContainer);

    const option = getChartOptions(theme, chartData);

    if (chartData.length > 0) {
      chart.setOption(option);
    } else {
      chart.setOption({});
    }

    return () => chart.dispose();
  }, [chartData, elementId, theme]);
};
